<div class="container-fluid nopadLR" id="headerId">
  <header class="header1 d-flex justify-content-between">
    <a
      href="javascript:void(0)"
      class="Infy_Applogo marL24"
      [ngStyle]="{ 'text-decoration': 'none', color: '#FFFFFF' }"
      (click)="backButton()"
      id="btn-InTAP"
    >
      InTAP
    </a>
    <div
      class="headerSearch d-flex relative padT16"
      style="width: fit-content"
      id="candSch_op"
      [ngClass]="{ 'flex-dirction': location1.path().endsWith('scheduler/search') }"
    >
      <div class="headerSearchInput d-flex" *ngIf="showSelect()" id="canSpn_op">
        <div style="align-self: center; width: 100px">
          <mat-select name="ampm" [(value)]="selectedSearch" id="SchSlct_op">
            <mat-option id="OptnCand_op" value="candidate">Candidate</mat-option>
            <mat-option id="optnReq_op" value="requisition">Requisition</mat-option>
          </mat-select>
        </div>
        <input
          #searchValue
          matInput
          id="InptVal_op"
          name="searchcandidate"
          autocomplete="off"
          placeholder="How can I help you today?"
          [formControl]="reqFormControl"
          (keydown.enter)="openDialogSearch($event.target, selectedSearch)"
          style="width: 300px"
        />
        <a
          id="AHref_op"
          href="javascript:void(0)"
          (click)="openDialogSearch(searchValue, selectedSearch)"
          class="infy_HeadersearchIcon1 iconinline icon x-24 search-icon"
        ></a>
      </div>
      <div class="headerSearchInput d-flex" style="width: auto" *ngIf="!showSelect()" id="SpanIf_op">
        <input
          id="SeachVal"
          #searchValue
          matInput
          name="searchbarinput"
          autocomplete="off"
          placeholder="How can I help you today?"
          [formControl]="canFormControl"
          (keydown.enter)="openDialogSearch($event.target, 'candidate')"
          (keypress)="keyPressedAlphabets($event)"
          style="width: 300px"
        />
        <a
          id="AHrefIf_op"
          href="javascript:void(0)"
          (click)="openDialogSearch(searchValue, 'candidate')"
          class="iconinline icon x-24 search-icon"
        ></a>
      </div>
      <mat-error
        id="patternError"
        *ngIf="reqFormControl.hasError('pattern') || canFormControl.hasError('pattern')"
        style="color: white; font-size: 80%; display: block; padding-left: 100px"
      >
        Following &#64;. ,_- special characters are allowed
      </mat-error>

      <div id="SpnLoctn" *ngIf="location1.path().endsWith('scheduler/search')" class="setAdvanceSearch">
        <a
          class="padT16 padL8"
          (click)="advanceSearch(true)"
          [ngStyle]="{ 'text-decoration': 'none', cursor: 'pointer', color: '#FFFFFF' }"
          id="btn-advSearch"
        >
          Advanced search
        </a>
        <a
          (click)="advanceSearch(false)"
          [ngStyle]="{ 'text-decoration': 'none', cursor: 'pointer', color: '#FFFFFF' }"
          id="btn-close"
        >
          <img src="assets/images/icons/white_icons/icon-close.png" alt="close" [ngStyle]="{ height: '22px' }" />
        </a>
      </div>
    </div>
    <div class="d-flex">
      <a
        class="Infy_Applogo marL24"
        (click)="logout()"
        [ngStyle]="{ 'text-decoration': 'none', cursor: 'pointer', color: '#FFFFFF' }"
        id="btn-logout"
      >
        Logout
      </a>
      <ul class="Infy_RightUtil marT16">
        <li>
          <a href="javascript:void(0)" class="Infy_Profile">
            <span *ngIf="loginUserName !== ''" class="data-letters float-left marR16 marL16">{{
              loginUserName | initials
            }}</span>
          </a>
        </li>
      </ul>
    </div>
  </header>
  <nav class="Infy_Appnav navHide" id="mainNav" [ngStyle]="{ width: '150px' }">
    <div class="clearfix">
      <a
        href="javascript:void(0)"
        class="Infy_Hamburger icon x-24 icon-Hamburger purple marL16 marT24 float-left"
        (click)="infy_mainHamburger()"
      ></a>
    </div>
    <h3 class="h3Header padLR16 marT32 marB24" id="headerinfyApps">Infy Apps</h3>
    <ul class="listItemSingle">
      <li>
        <a href="javascript:void(0)">
          <em class="icon x-24 icon-infyme marR16 float-left"></em>
          <h5 class="h5Header GreyDarkest list-1line" id="header-infyMe">InfyMe</h5>
        </a>
      </li>
      <li>
        <a href="javascript:void(0)">
          <em class="icon x-24 icon-work marR16 float-left"></em>
          <h5 class="h5Header GreyDarkest list-1line" id="header-work">Work</h5>
        </a>
      </li>
    </ul>
  </nav>
</div>
